import { z } from 'zod';

import { EmailTemplateType } from '../emails/Templates';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateSentEmailEvent = z.object({
  ...BaseLoanEvent.shape,
  type: z.literal('updateSentEmail'),
  emailTemplate: EmailTemplateType,
});

export type UpdateSentEmailEvent = z.infer<typeof UpdateSentEmailEvent>;
